// extracted by mini-css-extract-plugin
export default {"trustPilotCarousel":"style-module--trustPilotCarousel--0a67a"};